import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _objectSpread from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "addSwiper",
  data: function data() {
    return {
      form: {
        id: "",
        name: "",
        qr_code: "",
        hide_img: "",
        show_img: "",
        type: 2,
        url: [],
        custom_text: "",
        platform_type: "",
        is_open: "",
        language: ""
      },
      // locationList: [
      //   {
      //     label: "左边",
      //     value: 'left'
      //   },
      //   {
      //     label: "中间",
      //     value: 'content'
      //   },
      //   {
      //     label: "右边",
      //     value: 'content'
      //   }
      // ],
      typeList: [{
        label: "否",
        value: 2
      }, {
        label: "是",
        value: 1
      }],
      dialogShow: false,
      qr_code: [],
      hide_img: [],
      show_img: [],
      rules: {
        // sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        name: [{
          required: true,
          message: "请输入名字",
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "blur"
        }],
        // url: [{ required: true, message: "请输入链接", trigger: "blur" }],
        // hide_img: [{ required: true, message: "请上传图片", trigger: "blur" }],
        show_img: [{
          required: true,
          message: "请上传图片",
          trigger: "blur"
        }],
        is_open: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        platform_type: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        type: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var newData, arrs;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  newData = JSON.parse(JSON.stringify(data));
                  newData.url = newData.url ? newData.url : [];

                  if (newData.url instanceof Array) {
                    newData.url.map(function (i) {
                      i.picfileList = i.img ? [i.img] : [];
                    });
                  } else {
                    arrs = [{
                      url: newData[0].url,
                      picfileList: newData[0].img ? [newData[0].img] : [],
                      img: ''
                    }];
                    newData.url = [].concat(arrs);
                  }

                  _this.form = _objectSpread({}, newData);
                  _this['qr_code'] = newData.qr_code ? [newData.qr_code] : [];
                  _this['hide_img'] = newData.hide_img ? [newData.hide_img] : [];
                  _this['show_img'] = newData.show_img ? [newData.show_img] : [];
                }

                _this.dialogShow = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    imgChange: function imgChange(e, type) {
      this[type] = e;
      this.form[type] = e[0] && e[0].response ? e[0].response.data : '';
    },
    hide: function hide() {
      this.dialogShow = false;
    },
    addDomain: function addDomain() {
      this.form.url.push({
        url: '',
        picfileList: [],
        img: ''
      });
    },
    imgChangeT: function imgChangeT(e, item, index) {
      this.form.url[index].picfileList = e;
      this.form.url[index].img = e[0] && e[0].response ? e[0].response.data : '';
    },
    removeDomain: function removeDomain(item) {
      var index = this.form.url.indexOf(item);

      if (index !== -1) {
        this.form.url.splice(index, 1);
      }
    },
    clearData: function clearData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.form = {
        id: type ? this.form.id : "",
        name: "",
        qr_code: "",
        hide_img: "",
        show_img: "",
        url: [],
        custom_text: "",
        type: 2,
        is_open: "",
        language: "",
        platform_type: ""
      };
      this.qr_code = [], this.hide_img = [], this.show_img = [], this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.form));
          data.url.map(function (i) {
            delete i.picfileList;
          });
          data.platform_type = data.platform_type.toString();
          var reqFn = data.id ? 'downloadLinkUpdate' : 'downLoadLinkAdd';

          _this2.$api[reqFn](data).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.hide();

              _this2.$emit('change');
            }
          });
        }
      });
    }
  }
};